// extracted by mini-css-extract-plugin
export default {"checkboxList":"Checkbox_checkboxList__QM-Bw","customCheckbox":"Checkbox_customCheckbox__KsHA5"};